import FormInputWrapper from "shared/components/inputs/form/FormInputWrapper";
import PropTypes from "prop-types";
import RangeCalendarMain from "shared/components/date-controls/range-calendar/RangeCalendarMain";
import { useFormInput } from "shared/components/inputs/form-fields/utils";

const DateRangePicker = ({
    name,
    validations,
    label = "",
    description,
    helpText,
    className,
    onChange,
    disableDays,
    enableDaysFromDate,
    enableDaysUntilDate,
    minDate,
    maxWidth,
    ...rest
}) => {
    const { wrapperProps, inputProps } = useFormInput({
        name,
        validations,
        isControlled: true,
    });

    const confirmedChange = (dateValue) => {
        onChange(dateValue);
    };

    const feedbackMessageData =
        (!inputProps?.value || inputProps?.value) &&
        wrapperProps?.feedbackMessage;

    return (
        <FormInputWrapper
            {...{ label, description, helpText, className }}
            {...wrapperProps}
            feedbackMessage={feedbackMessageData}
            maxWidth={maxWidth}
        >
            <RangeCalendarMain
                {...rest}
                {...inputProps}
                label={label}
                feedbackType={inputProps.feedbackType}
                confirmedChange={confirmedChange}
                disableDays={disableDays}
                enableDaysFromDate={enableDaysFromDate}
                enableDaysUntilDate={enableDaysUntilDate}
                minDate={minDate}
                feedbackMessage={feedbackMessageData}
            />
        </FormInputWrapper>
    );
};

DateRangePicker.propTypes = {
    name: PropTypes.string.isRequired,
    validations: PropTypes.object,
    label: PropTypes.string,
    description: PropTypes.string,
    helpText: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    disableDays: PropTypes.array,
    enableDaysFromDate: PropTypes.number,
    enableDaysUntilDate: PropTypes.number,
    minDate: PropTypes.object,
    maxWidth: PropTypes.string,
};

export default DateRangePicker;
